const config = {
  accessToken: 'pk.eyJ1IjoidHNsZXNzYXIiLCJhIjoiY2wzbnhwd2NrMGc4YzNqb3lzaGRmMGZtMCJ9._N9iGqhOeotYl7CkfvE16A',
  style: 'mapbox://styles/tslessar/cl5g636bj000214qzia5itrhg',
  center: [134.50730925711218, -25.802447709032535],
  zoom: 3,
};

export default config;
